import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

import BaseOrderView from './BaseOrderView';

const DEFAULT_COLUMN_WIDTH = '7.5em';

const GRID_COLUMNS = [
  {
    field: 'instrumentId',
    columnHeader: strings.dataViewing.tableHeaders.instrumentId,
    width: '15em',
    sortable: true
  },
  {
    field: 'date',
    columnHeader: strings.dataViewing.tableHeaders.date,
    width: '12em',
    sortable: true,
    sortConfig: { direction: 'DESC'}
  },
  {
    field: 'bidPrice',
    columnHeader: strings.dataViewing.tableHeaders.bidPrice,
    width: DEFAULT_COLUMN_WIDTH
  },
  {
    field: 'bidCurrency',
    columnHeader: strings.dataViewing.tableHeaders.bidCurrency,
    width: '7em'
  },
  {
    field: 'bidVol',
    columnHeader: strings.dataViewing.tableHeaders.bidVol,
    width: DEFAULT_COLUMN_WIDTH
  },
  {
    field: 'askPrice',
    columnHeader: strings.dataViewing.tableHeaders.askPrice,
    width: DEFAULT_COLUMN_WIDTH
  },
  {
    field: 'askCurrency',
    columnHeader: strings.dataViewing.tableHeaders.askCurrency,
    width: '7em'
  },
  {
    field: 'askVol',
    columnHeader: strings.dataViewing.tableHeaders.askVol,
    width: DEFAULT_COLUMN_WIDTH
  },
  {
    field: 'marketMaker',
    columnHeader: strings.dataViewing.tableHeaders.marketMaker,
    width: '8em',
    required: false
  },
  {
    field: 'tradingSystem',
    columnHeader: strings.dataViewing.tableHeaders.tradingSystem,
    width: '8em',
    required: false
  },
  {
    field: 'tradingSystemPhase',
    columnHeader: strings.dataViewing.tableHeaders.tradingSystemPhase,
    width: '8em',
    required: false
  },
  {
    field: 'aggregatedQuotesAndOrder',
    columnHeader: strings.dataViewing.tableHeaders.aggregatedQuotesAndOrder,
    width: '8em',
    required: false
  }
];

const GRID_COLUMNS_UK = [
  {
    field: 'instrumentId',
    columnHeader: strings.dataViewing.tableHeaders.instrumentId,
    width: '15em',
    sortable: true
  },
  {
    field: 'date',
    columnHeader: strings.dataViewing.tableHeaders.date,
    width: '12em',
    sortable: true,
    sortConfig: { direction: 'DESC'}
  },
  {
    field: 'bidPrice',
    columnHeader: strings.dataViewing.tableHeaders.bidPrice,
    width: DEFAULT_COLUMN_WIDTH
  },
  {
    field: 'bidCurrency',
    columnHeader: strings.dataViewing.tableHeaders.bidCurrency,
    width: '7em'
  },
  {
    field: 'bidVol',
    columnHeader: strings.dataViewing.tableHeaders.bidVol,
    width: DEFAULT_COLUMN_WIDTH
  },
  {
    field: 'askPrice',
    columnHeader: strings.dataViewing.tableHeaders.askPrice,
    width: DEFAULT_COLUMN_WIDTH
  },
  {
    field: 'askCurrency',
    columnHeader: strings.dataViewing.tableHeaders.askCurrency,
    width: '7em'
  },
  {
    field: 'askVol',
    columnHeader: strings.dataViewing.tableHeaders.askVol,
    width: DEFAULT_COLUMN_WIDTH
  }
];

class VoiceOrderView extends Component {
  render() {
    const columns = this.props.order.venueLocation === 1 ? GRID_COLUMNS_UK : GRID_COLUMNS;
    return <BaseOrderView gridColumns={columns} showExpandCollapse={true} {...this.props} />;
  }
}

export default VoiceOrderView;



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/VoiceOrderView.jsx